import React from 'react';
import styled from 'styled-components';
import type { SmartSortingCategorySummary } from '../../../types/api';
import { SmartSortingCategoryCard } from './SmartSortingCategoryCard';

const Grid = styled.div`
  display: grid;
  width: 100%;
  min-width: 0;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

interface SmartSortingCategoryGridProps {
  categories: SmartSortingCategorySummary[];
}

export const SmartSortingCategoryGrid: React.FC<
  SmartSortingCategoryGridProps
> = ({ categories }) => {
  return (
    <Grid>
      {categories.map((cat) => (
        <SmartSortingCategoryCard key={cat.key} category={cat} />
      ))}
    </Grid>
  );
};
